module.exports = __webpack_public_path__ + "media/Z23.a9f23195.mp3";